// src/app/services/axios-service/axios.factory.ts
import axios, { AxiosInstance } from 'axios';
import { environment } from '../../../../environments/environment';
import { LocalStorageService, StorageKeys } from '../local-storage/local-storage.service';


const localStorageService = new LocalStorageService();

export enum ApiType {
  Auth = 'Auth',
  Org = 'Org',
  School = 'School',
  Fee = 'Fee',
  Shared = 'Shared',
  Student = 'Student'
}

/** Returns an Axios instance for the requested service */
export const getApiClient = (type: ApiType): AxiosInstance => {
  let baseURL = '';
  switch (type) {
    case ApiType.Auth:
      baseURL = environment.AuthServiceBaseUrl;
      break;
    case ApiType.Org:
      baseURL = environment.OrgServiceBaseUrl;
      break;
    case ApiType.School:
      baseURL = environment.SchoolServiceBaseUrl;
      break;
    case ApiType.Fee:
      baseURL = environment.FeeServiceBaseUrl;
      break;
    case ApiType.Shared:
      baseURL = environment.SharedServiceBaseUrl;
      break;
    case ApiType.Student:
      baseURL = environment.StudentServiceBaseUrl;
      break;
    default:
      throw new Error('Invalid API type');
  }

  const instance = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Attach JWT token automatically if available
  instance.interceptors.request.use((config) => {
  if (!config.url?.includes('/Login')) { // skip login
    const token = localStorageService.getItem(StorageKeys.AccessToken);
    if (token) { 
      config.headers.set('Authorization', `Bearer ${token}`);
    }
  }
  return config;
});

  return instance;
};
